// Finishing options row: Stapling · Lamination · Batch copies.
// These three toggles have interdependent state so keep them grouped.

import { Paperclip, Shield, Combine } from "lucide-react";
import { ksh } from "@/lib/api";
import { ORDER } from "@/constants/testIds";
import { Toggle } from "./_shared";

export function FinishingSection({ idx, spec, pricing, onUpdate }) {
  return (
    <>
      <Toggle
        active={spec.stapling}
        onClick={() => spec.binding === "none" && !spec.lamination && onUpdate({ stapling: !spec.stapling })}
        disabled={spec.binding !== "none" || spec.lamination}
        icon={Paperclip}
        label={
          spec.binding !== "none"
            ? "Stapling (binding is on)"
            : spec.lamination
            ? "Stapling (lamination on)"
            : `Stapling (+${ksh(pricing.stapling)}/booklet)`
        }
        testId={`${ORDER.specStapling}-${idx}`}
      />
      <Toggle
        active={spec.lamination}
        onClick={() => spec.binding === "none" && !spec.stapling && onUpdate({ lamination: !spec.lamination })}
        disabled={spec.binding !== "none" || spec.stapling}
        icon={Shield}
        label={
          spec.binding !== "none"
            ? "Lamination (binding is on)"
            : spec.stapling
            ? "Lamination (stapling on)"
            : `Lamination (+${ksh(pricing.lamination?.[spec.paper_size] || 0)}/pg)`
        }
        testId={`${ORDER.specLamination}-${idx}`}
      />
      {(() => {
        const canBatch = (spec.binding !== "none" || spec.stapling) && spec.copies > 1;
        const batchLabel = !canBatch
          ? (spec.copies <= 1
              ? "Batch copies (need ≥ 2 copies)"
              : "Batch copies (needs binding/stapling)")
          : `Batch as one ${spec.pages * spec.copies}-page ${spec.binding !== "none" ? "book" : "stack"}`;
        return (
          <Toggle
            active={!!spec.batch_copies}
            onClick={() => canBatch && onUpdate({ batch_copies: !spec.batch_copies })}
            disabled={!canBatch}
            icon={Combine}
            label={batchLabel}
            testId={`spec-batch-copies-${idx}`}
          />
        );
      })()}
    </>
  );
}
